/* global jQuery */

export default class PriceTable {
  ready () {
    jQuery(document).on('click', '[data-security-deposit]', this.handlePriceTableChange)
  }

  handlePriceTableChange (e) {
    e.preventDefault()

    const button = jQuery(e.currentTarget)
    const securityDeposit = button.attr('data-security-deposit')

    // Button classes
    jQuery('[data-security-deposit]')
        .addClass('transparent')
        .removeClass('primary')
    button
        .addClass('primary')
        .removeClass('transparent')


    jQuery('[data-security-deposity-body]')
        .removeClass('mtt-price-table__body--active')

    jQuery('[data-security-deposity-body="' + securityDeposit +'"]')
        .addClass('mtt-price-table__body--active')
  }
}
